import React from "react";
import { Snackbar, Alert } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

const GlobalSnackbar = ({ snackbar, handleClose }) => {
  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }} // Positioned on the left side
    >
      <Alert
        onClose={handleClose}
        severity={snackbar.severity}
        icon={
          snackbar.severity === "success" ? (
            <CheckCircleIcon sx={{ color: "var(--secondary-color)" }} />
          ) : (
            <ErrorIcon sx={{ color: "var(--secondary-color)" }} />
          )
        }
        style={{
          backgroundColor:
            snackbar.severity === "success"
              ? "var(--snackbarSuccess-color)"
              : "var(--error-color)", // Now works!
          color: "var(--secondary-color)",
          display: "flex",
          alignItems: "center",
        }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
};

export default GlobalSnackbar;
